const getFormattedOutstandingStatus = ({ item }: { item: any }) => {
  const status = item.orderStatus;
  if (['CONFIRMED'].includes(status) && item.shippingStatus === 'DISPATCHED') {
    return 'DISPATCHED';
  }
  return status;
};

export default getFormattedOutstandingStatus;
